import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import PortalApi from "api/PortalApi";
import { slugify } from "utils/slugify";
import styled from "styled-components";
import tw from "twin.macro";
import { EventList } from "models/Response/Portal";

// Tarih başlığı
const DateHeader = tw.div`flex items-center justify-center my-6 space-x-4`;
const NavButton = tw.button`text-xl font-bold px-3 py-1 bg-gray-200 rounded hover:bg-gray-300`;
const MonthYearText = tw.h2`text-2xl font-semibold text-primary-700`;

const TableWrapper = styled.div`
  ${tw`px-2 sm:px-4`}
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
`;

const HoverRow = styled.tr`
  ${tw`
    transition-all duration-200
    hover:shadow-md
    hover:border-l-4
    hover:border-primary-500
  `}
`;

const Table = tw.table`
  w-full table-fixed border border-gray-300
`;
const Th = tw.th`
  bg-gray-100 p-3 text-left border-b border-gray-300 text-sm font-semibold text-gray-700
  break-words whitespace-normal
`;

const Td = tw.td`
  p-3 border-b border-gray-200 text-sm text-gray-800 cursor-pointer hover:bg-gray-100
  break-words whitespace-normal
`;

const ClickableTd = styled.td`
  ${tw`
    p-3 border-b border-gray-200 text-sm text-gray-800
    break-words whitespace-normal
  `}
  cursor: pointer;
  &:hover {
    background-color: transparent;
  }
`;

const NormalTd = tw.td`
  p-3 border-b border-gray-200 text-sm text-gray-800
  break-words whitespace-normal
`;



interface EventItem {
    id: number;
    title: string;
    date: string;
    location: string;
}

const months = [
    "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
    "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
];

const Etkinlikler: React.FC = () => {
    const today = new Date();
    const [currentMonth, setCurrentMonth] = useState(today.getMonth());
    const [currentYear, setCurrentYear] = useState(today.getFullYear());
    const [events, setEvents] = useState<EventList[]>([]);

    const fetchEvents = async () => {
        try {
            const response = await PortalApi.getEvents(currentYear, currentMonth + 1);
            if (response?.content?.eventList) {
                setEvents(response.content.eventList);
            }
        } catch (err) {
            console.error("Etkinlikler alınamadı:", err);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, [currentMonth, currentYear]);

    const changeMonth = (direction: "prev" | "next") => {
        let newMonth = currentMonth + (direction === "next" ? 1 : -1);
        let newYear = currentYear;

        if (newMonth < 0) {
            newMonth = 11;
            newYear -= 1;
        } else if (newMonth > 11) {
            newMonth = 0;
            newYear += 1;
        }

        setCurrentMonth(newMonth);
        setCurrentYear(newYear);
    };

    return (
        <Layout>
            <BasicHeader
                headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe"
                headingLine2=""
            />

            <DateHeader>
                <NavButton onClick={() => changeMonth("prev")}>←</NavButton>
                <MonthYearText>{months[currentMonth]} {currentYear}</MonthYearText>
                <NavButton onClick={() => changeMonth("next")}>→</NavButton>
            </DateHeader>
            <div className="text-center text-sm text-gray-600 mb-2">
                <strong>Not:</strong> Etkinlik detayını incelemek için etkinlik bilgisine tıklayınız.
            </div>
            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            <Th>Etkinlik</Th>
                            <Th>Tarih</Th>
                            <Th>Yer</Th>
                        </tr>
                    </thead>
                    <tbody>
                        {events.map((event) => (
                             <HoverRow key={event.eventId}>
                                <ClickableTd
                                    onClick={() =>
                                        window.open(
                                            `/EtkinlikDetay/${slugify(event.eventName)}/${event.eventId}`,
                                            "_blank"
                                        )
                                    }
                                >
                                    {event.eventName}
                                </ClickableTd>
                                <ClickableTd onClick={() =>
                                        window.open(
                                            `/EtkinlikDetay/${slugify(event.eventName)}/${event.eventId}`,
                                            "_blank"
                                        )
                                    }>
                                    {new Date(event.startDate).toLocaleDateString("tr-TR")} -{" "}
                                    {new Date(event.finishDate).toLocaleDateString("tr-TR")}
                                </ClickableTd >
                                <ClickableTd onClick={() =>
                                        window.open(
                                            `/EtkinlikDetay/${slugify(event.eventName)}/${event.eventId}`,
                                            "_blank"
                                        )
                                    }>{event.eventPlace}</ClickableTd>
                            </HoverRow>
                        ))}
                    </tbody>
                </Table>

            </TableWrapper>
        </Layout>
    );
};

export default Etkinlikler;
